<template>
<footer class="footer">
<div class="container">
<div class="footer-top">
<div class="footer-brand">
<router-link to="/" class="brand brand-light">
 <span class="brand-logo">
    <img src="@/assets/img/logo.jpg"/>
 </span>
 <span>
 <strong>Lakesail</strong>
 <small>Properties</small>
</span>  
</router-link>
<p>Thoughtful property solutions for people, families and investors building their future in real estate.</p>
<div class="socials">
<a href="#" aria-label="Instagram">ig</a>
<a href="#" aria-label="LinkedIn">in</a>
<a href="#" aria-label="Facebook">f</a>
</div>
</div>
<div>
<h4>Explore</h4>
<router-link to="/properties">Properties</router-link>
<router-link to="/services">Services</router-link>
<router-link to="/projects">Projects</router-link>
<router-link to="/about">About</router-link>
</div>
<div>
<h4>Insights</h4>
<router-link to="/blog">Market Insights</router-link>
<router-link to="/blog">Buying Guides</router-link>
<router-link to="/blog">Property Management</router-link>
<router-link to="/contact">Contact Us</router-link>
</div>
<div class="footer-contact">
<h4>Visit us</h4>
<p>Suite 18 wina ofure complex<br>off shagamu road odogunyan, Ikorodu</p>
<a href="tel:+2348012345678">+234 801 234 5678</a>
<a href="mailto:hello@aureliaproperties.ng">hello@companyname.ng</a>
</div>
</div>
<div class="newsletter">
<div>
<span class="eyebrow">PROPERTY NOTES</span>
<h3>Useful insights, delivered occasionally.</h3>
</div>
<form @submit.prevent="subscribed=true">
<input type="email" required placeholder="Your email address" aria-label="Email address">
<button type="submit">{{subscribed?'Subscribed':'Subscribe'}} <span>→</span>
</button>
</form>
</div>
<div class="footer-bottom">
<span>© {{year}} CHIMA ORDU & COMPANY. All rights reserved.</span>
<span>Privacy · Terms</span>
</div>
</div>
</footer>
</template>
<script>export default {name:'Footer',data(){return{subscribed:false}},computed:{year(){return new Date().getFullYear()}}}</script>
